import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=b0bb42d0"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0bb42d0')) {
      api.createRecord('b0bb42d0', component.options)
    } else {
      api.reload('b0bb42d0', component.options)
    }
    module.hot.accept("./Survey.vue?vue&type=template&id=b0bb42d0", function () {
      api.rerender('b0bb42d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/Survey.vue"
export default component.exports